<template>
  <div class="flex items-center space-x-8">
    <RevButtonIcon
      :icon="IconArrowLeft"
      variant="secondary"
      @click="emit('click')"
    />
    <span>{{ i18n(translations.back) }}</span>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButtonIcon } from '@ds/components/ButtonIcon'
import { IconArrowLeft } from '@ds/icons/IconArrowLeft'

import translations from './Back.translations'

const i18n = useI18n()

const emit = defineEmits(['click'])
</script>
